export enum AppUserRoleEnum {
   BASE,
   ADMIN
}
